import { render, staticRenderFns } from "./PgaDeliverableEdit.vue?vue&type=template&id=209ac1d4&"
import script from "./PgaDeliverableEdit.vue?vue&type=script&lang=ts&"
export * from "./PgaDeliverableEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('209ac1d4')) {
      api.createRecord('209ac1d4', component.options)
    } else {
      api.reload('209ac1d4', component.options)
    }
    module.hot.accept("./PgaDeliverableEdit.vue?vue&type=template&id=209ac1d4&", function () {
      api.rerender('209ac1d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/business-startups/customer-orders/components/edit/sub-components/PgaDeliverableEdit.vue"
export default component.exports